import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { AE_ICON_SIZE } from '@/components/assessment-engine/layout/aeTheme';

interface SectionCollapseToggleProps {
  expanded: boolean;
  label: string;
  onToggle: () => void;
}

/** Expand/collapse control for section and subsection blocks in the template builder. */
export const SectionCollapseToggle: React.FC<SectionCollapseToggleProps> = ({
  expanded,
  label,
  onToggle,
}) => (
  <button
    type="button"
    className="shrink-0 rounded p-0.5 text-[var(--color-secondary-text)] hover:text-[var(--color-primary-text)] focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
    onClick={onToggle}
    aria-expanded={expanded}
    aria-label={label}
  >
    <ChevronDownIcon
      className={`${AE_ICON_SIZE} transition-transform ${expanded ? '' : '-rotate-90'}`}
      aria-hidden
    />
  </button>
);
